export default __webpack_public_path__ + "static/media/podcast.74c092f7.svg";